<template>
  <div>
    <breadcrumb-bar
      :crumbs="[{name:'Administrative Settings'},{name: 'Data Import', link:'Imports Select'}, {name:'Import History'}]"></breadcrumb-bar>
    <div class="col-md-12">
      <div class="row">
        <div class="portlet light">
          <div class="portlet-title">
            <div class="caption caption-md">
              <span class="caption-subject bold uppercase">Import History</span>
            </div>
          </div>
          <div class="portlet-body">
            <vue-spinner v-if="loading"></vue-spinner>
            <vue-good-table v-else :columns="columns" :rows="history.imports" :pagination-options="{enabled: true}">
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field=='original_file'">
                  {{ (props.row.original_file) ? props.row.original_file : props.row.file }}
                </span>
                <span v-else-if="props.column.field=='created.date.date'">
                  {{ props.row.created.by }} on {{ props.row.created.date.date | formatDate }}
                </span>
                <span v-else-if="props.column.field=='status'">
                  {{ props.row.success_rows_count }} of {{ props.row.total_import_rows_count }} records <span
                  class="label label-sm label-warning capitalize"> {{ getStatus(props.row.status) }} </span>
                </span>
                <span v-else-if="props.column.field=='after'">
                  <router-link :to="{name: 'Imports History Single', params: {id: props.row.id}}" tag="button"
                               class="btn btn-xs green">View</router-link>
                </span>
                <span v-else>{{ props.formattedRow[props.column.field] }}</span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Breadcrumbs from '@/components/Breadcrumbs'
import Spinner from "../components/Spinner";

export default {
  data() {
    return {
      loading: true,
      columns: [
        {
          label: 'File Name',
          field: 'original_file',
          filterOptions: {enabled: false}
        },
        {
          label: 'Form Name',
          field: 'form.name',
          filterOptions: {enabled: false}
        },
        {
          label: 'Imported By',
          field: 'created.date.date',
          filterOptions: {enabled: false}
        },
        {
          label: 'Imported Status',
          field: 'status',
          filterOptions: {enabled: false}
        },
        {
          label: 'Actions',
          field: 'after',
          filterOptions: {enabled: false}
        }
      ],
    }
  },
  components: {
    'breadcrumb-bar': Breadcrumbs,
    'vue-spinner': Spinner
  },
  computed: {
    ...mapGetters({
      history: 'getImportsHistory'
    })
  },
  methods: {
    ...mapActions({
      getHistory: 'IMPORTS_HISTORY_ACTION'
    }),
    getStatus(status) {
      return (status == 'progress') ? 'Processing' : status;
    }
  },
  mounted() {
    this.getHistory().then(() => {
        this.loading = false;
      }
    )
  }
}
</script>
<style scoped>
.capitalize {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// ImportsHistory.vue?885afcd0